import {GET_ALL_LEADS} from '../actions/types';

const initialState = {
  leads: [],
};

const leadReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_LEADS:
      return Object.assign({}, state, {
        leads: action.payload,
      });
    default:
      return state;
  }
};

export default leadReducer;
